export const NOT_MODIFIED = 304;
export const UNPROCESSABLE_ENTITY = 422;
export const UNAUTHORIZED = 401;



